import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modeRadio", "specificSitesContainer", "siteSelect", "showDrivingTime"]
  static values = { url: String, cancelUrl: String, errorMessage: String }

  connect() {
    this.toggleSpecificSites()
  }

  toggleSpecificSites() {
    const selectedMode = this.modeRadioTargets.find((r) => r.checked)?.value

    if (this.hasSpecificSitesContainerTarget) {
      if (selectedMode === "specific") {
        this.specificSitesContainerTarget.classList.remove("hidden")
      } else {
        this.specificSitesContainerTarget.classList.add("hidden")
      }
    }
  }

  async save(event) {
    event.preventDefault()

    const selectedMode = this.modeRadioTargets.find((r) => r.checked)?.value
    const specificSiteIds =
      selectedMode === "specific"
        ? Array.from(this.siteSelectTarget.selectedOptions).map((o) => o.value)
        : []

    const csrfToken = document.querySelector("[name='csrf-token']")?.content

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          Accept: "text/vnd.turbo-stream.html",
        },
        body: JSON.stringify({
          mode: selectedMode,
          specific_site_ids: specificSiteIds,
          show_driving_time: this.hasShowDrivingTimeTarget
            ? this.showDrivingTimeTarget.checked
            : false,
        }),
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      } else {
        throw new Error("Update failed")
      }
    } catch (error) {
      console.error("Error updating site limitation:", error)
      alert(this.errorMessageValue || "Error saving. Please try again.")
    }
  }

  cancel(event) {
    event.preventDefault()

    // Use Turbo to reload the frame from the cancel URL
    const frame = document.getElementById("core_field_site_id")
    if (frame && this.cancelUrlValue) {
      frame.src = this.cancelUrlValue
      frame.reload()
    }
  }
}
